<google-map
  height="400px"
  width="100%"
  [zoom]="zoom"
  [center]="center"
  [options]="mapOptions"
  (mapClick)="onMapClick($event)"
>
  <map-marker
    *ngIf="markerPosition"
    [position]="markerPosition!"
    [options]="markerOptions"
    (mapDragend)="onMarkerDragEnd($event)"
  ></map-marker>
</google-map>
